import React, {useRef, useState, useMemo, useEffect} from "react";
import {useFrame, useThree} from "react-three-fiber";
import { a, useSpring } from '@react-spring/three'
import * as THREE from "three";
import { Html } from "@react-three/drei"

import './Imatge.css';

const Imatge = (props) => {
	const mesh = useRef();

	const [hovered, setHovered] = useState(false)
	const [visible, setVisible] = useState(0)
	const [inHoverDistance, setInHoverDistance] = useState(true)

	useEffect(() => {
		document.body.style.cursor = hovered ? 'pointer' : 'auto'
	}, [hovered])

	const {camera} = useThree()

	const lookAt = (mesh, x, y, z) => {
		if (mesh.current === null) {
			return;
		}

		const _target = new THREE.Vector3();
		if (x.isVector3) {
			_target.copy(x);
		} else {
			_target.set(x, y, z);
		}
		mesh.current.rotation.y = Math.atan2((_target.x - mesh.current.position.x), (_target.z - mesh.current.position.z));
	}

	const click = (e) => {
		e.stopPropagation();
		window.location.assign(props.link)
	}

	const onPointerOver = (e) => {
		e.stopPropagation();
		setHovered(true);
	}

	const onPointerOut = () => {
		setHovered(false);
	}

	useFrame(() => {
		lookAt(mesh, camera.position)

		const d = mesh.current.position.distanceTo( camera.position );
		if ((d > props.radius * 0.9) && (visible > 0)) {
			setVisible(0);
		} else if ((d < props.radius * 0.9) && (visible < 1)) {
			setVisible(1);
		}

		const inHD = d < props.radius * 0.7;
		if (inHoverDistance !== inHD) {
			setInHoverDistance(inHD);
		}
	});

	const textureLoaded = () => {
		setVisible(1);
	}

	const texture = useMemo(() => new THREE.TextureLoader().load(props.src, textureLoaded), []);

	const { opacity } = useSpring({
		opacity: visible ? 1 : 0,
		config: { duration: 500 }
	})

	const { scale } = useSpring({
		scale: hovered ? 1.52 : 1.5,
		config: { duration: 200 }
	})

	return (
		<a.mesh
			{...props}
			ref={mesh}
			scale-x={scale}
			scale-y={scale}
			onClick={(e) => click(e)}
			onPointerOver={(e) => onPointerOver(e)}
			onPointerOut={() => onPointerOut()}
		>
			<planeBufferGeometry args={[props.ratio / 2, 1 / (props.ratio * 2)]}/>
			<a.meshBasicMaterial attach="material" transparent side={THREE.DoubleSide} opacity={opacity}>
				<primitive attach="map" object={texture}/>
			</a.meshBasicMaterial>
			<Html
				className={'categoria_wrapper'}
				position={[0, -0.26, 0]}
			>
				<div className={`categoria ${hovered && inHoverDistance ? "visible" : ""}`}>
					{props.pagina}
				</div>
			</Html>
		</a.mesh>
	);
}
export default Imatge;